import { createSlice } from '@reduxjs/toolkit';
import { deleteReport } from '../../../rtk-apis/reports/deleteReport';

const initialState = {
  status: '',
  data: '',
  msg: '',
  loading: false,
};

const deleteReportSlice = createSlice({
  name: 'deleteReportSlice',
  initialState,
  reducers: {
    clearDeleteReport: state => {
      state.status = '';
      state.data = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(deleteReport.pending, state => {
        state.loading = true;
      })
      .addCase(deleteReport.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data;
        state.msg = action?.payload?.msg;
      })
      .addCase(deleteReport.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearDeleteReport } = deleteReportSlice.actions;
export default deleteReportSlice.reducer;
